<template>
  <div class="matcher">
    <div class="flex">
      <div class="input--block input--block--margin input--block--padded">
        <label
          class="form--label"
          v-tooltip="$t('merchant_merchant_matcher_text_case_insensitive_info')"
        >{{$t('merchant_merchant_matcher_text').toUpperCase()}}</label>
        <div class="Form-field">
          <input
            type="text"
            v-model="value.text"
            class="Input-text"
            @blur="handleBlur"
          >
        </div>
      </div>
      <button
        type="button"
        @click="handleDelete()"
        class="Fuell-IconButton button-delete"
      >
        <img
          alt="icon-trash"
          :src="require('@/assets/img/icons/icon-trash.svg')"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleBlur () {
      this.$emit('blur')
    },
    handleDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>
.matcher {
  padding: 1px 10px 10px;
  background-color: var(--fill-text-area);
  border-radius: 4px;
  margin-bottom: 10px;
}
</style>
